import { PalmettoLoader } from '@palmetto/dsm-components';
import classNames from 'classnames';
import React from 'react';

import styles from './LoadingContent.module.scss';

export interface Props {
  className?: string;
}

const LoadingContent: React.FC<Props> = ({ className }: Props) => (
  <div className={classNames(styles.loading, className)}>
    <PalmettoLoader label="loading" />
  </div>
);

export default LoadingContent;
